module.exports = __webpack_public_path__ + "static/media/jp.889c5f73.svg";